export default __webpack_public_path__ + "static/media/aboutTrainer.0a986928.webp";